<template>
    <div class="m-jx3code m-sideblock" v-if="data && data.length">
        <div class="m-jx3code-header m-sideblock-header">
            <div class="u-left">
                <span class="u-title"
                    ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M495.484 107.355H115.613v8.258a8.253 8.253 0 01-8.258 8.258 8.253 8.253 0 01-8.258-8.258v-8.258H16.516C7.395 107.355 0 114.749 0 123.871v72.697c0 4.163 2.047 8.119 5.587 10.309 16.459 10.18 27.445 28.347 27.445 49.123 0 20.775-10.986 38.943-27.445 49.123C2.047 307.313 0 311.27 0 315.432v72.697c0 9.121 7.395 16.516 16.516 16.516h82.581v-8.258a8.253 8.253 0 018.258-8.258 8.253 8.253 0 018.258 8.258v8.258h379.871c9.121 0 16.516-7.395 16.516-16.516V123.871c0-9.122-7.395-16.516-16.516-16.516zm-379.871 256a8.253 8.253 0 01-8.258 8.258 8.253 8.253 0 01-8.258-8.258v-16.516a8.253 8.253 0 018.258-8.258 8.253 8.253 0 018.258 8.258v16.516zm0-49.549a8.253 8.253 0 01-8.258 8.258 8.253 8.253 0 01-8.258-8.258V297.29a8.253 8.253 0 018.258-8.258 8.253 8.253 0 018.258 8.258v16.516zm0-49.548a8.253 8.253 0 01-8.258 8.258 8.253 8.253 0 01-8.258-8.258v-16.516a8.253 8.253 0 018.258-8.258 8.253 8.253 0 018.258 8.258v16.516zm0-49.548a8.253 8.253 0 01-8.258 8.258 8.253 8.253 0 01-8.258-8.258v-16.516a8.253 8.253 0 018.258-8.258 8.253 8.253 0 018.258 8.258v16.516zm0-49.549a8.253 8.253 0 01-8.258 8.258 8.253 8.253 0 01-8.258-8.258v-16.516a8.253 8.253 0 018.258-8.258 8.253 8.253 0 018.258 8.258v16.516z" fill="#ffc350"/><path d="M487.226 388.129H140.387a8.258 8.258 0 01-8.258-8.258V132.129a8.258 8.258 0 018.258-8.258h346.839a8.258 8.258 0 018.258 8.258v247.742a8.258 8.258 0 01-8.258 8.258z" fill="#ffd164"/><path d="M306.974 313.068L264.17 339.94c-9.433 5.922-21.271-2.678-18.554-13.48l12.33-49.013-38.784-32.405c-8.548-7.142-4.026-21.058 7.087-21.811l50.424-3.419 18.834-46.9c4.151-10.336 18.783-10.336 22.934 0l18.834 46.9 50.424 3.419c11.113.754 15.635 14.67 7.087 21.811l-38.784 32.405 12.33 49.013c2.717 10.802-9.12 19.403-18.554 13.48l-42.804-26.872z" fill="#fff"/><path d="M362.96 305.111c-53.511-3.271-98.879-36.395-119.61-83.039l-17.101 1.159c-11.113.754-15.635 14.67-7.087 21.811l38.784 32.405-12.331 49.013c-2.717 10.802 9.12 19.402 18.554 13.48l42.804-26.872 42.803 26.872c9.433 5.922 21.271-2.678 18.553-13.48l-5.369-21.349z" fill="#fff6d8"/></svg>今日福利</span
                >
            </div>
            <div class="u-right">
                <span class="u-time">
                    {{ showTime(time) }}
                </span>
            </div>
        </div>
        <div class="m-jx3code-content">
            <div class="u-codebox" v-for="(item, i) in data" :key="i">
                <div class="u-code" @click="copy(item.title)" :style="{ color: item.color || '#f98003' }">
                    {{ item.title }}
                </div>
                <div class="u-desc">{{ item.desc }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCode } from "@/service/cms";
import { showTime } from "@jx3box/jx3box-common/js/moment";
export default {
    props: [],
    data: function () {
        return {
            data: [],
        };
    },
    computed: {
        client: function () {
            return this.$store.state.client;
        },
        time: function () {
            return this.data?.[0]?.updated_at ? new Date(this.data?.[0]?.updated_at) : new Date();
        },
    },
    methods: {
        copy(text) {
            navigator.clipboard.writeText(text);
            this.$message({
                message: "复制成功",
                type: "success",
            });
        },
        showTime,
    },
    created: function () {
        getCode(this.client).then((res) => {
            this.data = res.data.data.list || [];
        });
    },
    components: {},
};
</script>
<style lang="less">
@import "~@/assets/css/v3/jx3code.less";
</style>
